module.exports = " <div class=group _v-0da1d26f=\"\"> <button :class=\"{'white': whites.indexOf(n) > -1, 'black': blacks.indexOf(n) > -1}\" v-for=\"n in 12\" :style=\"{ left: calcLeft(n) + '%' }\" data-note={{start+n}} @click=play(start+n) _v-0da1d26f=\"\"><span v-show=\"n === 0\" _v-0da1d26f=\"\">C</span></button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0da1d26f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Group.vue
 ** module id = 9
 ** module chunks = 2
 **/